import Component from '@glimmer/component';

export default class StyleguideContainer extends Component {
  mockFunction(...rest: any[]) {
    // eslint-disable-next-line no-console
    console.log('mock function was called', ...rest);
  }
}
